import { createSlice } from '@reduxjs/toolkit';
import { Actividades_Estudiante_Grupo_Temporal } from 'generated/graphql';

const initialState: {
	cursoKey: string;
	isColaborativa: boolean;
	grupoTemporalKey: string | undefined;
	grupoTemporal: Actividades_Estudiante_Grupo_Temporal[];
} = null as any;

const currentGrupoTemporalSlice = createSlice({
	name: 'currentGrupoTemporal',
	initialState,
	reducers: {
		setCurrentGrupoTemporal: (state, action) => {
			return action.payload;
		},
		resetCurrentGrupoTemporal: () => {
			return initialState;
		}
	}
});

export const { setCurrentGrupoTemporal, resetCurrentGrupoTemporal } = currentGrupoTemporalSlice.actions;

export default currentGrupoTemporalSlice.reducer;
